import {
  Checkbox,
  ConfigProvider,
  Divider,
  Flex,
  message,
  Space,
  Spin,
  Tabs,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { Button, TimePicker } from "antd";
import TimeRangeSelector from "../../Components/TimeRangeSelector/TimeRangeSelector";
import { useDispatch, useSelector } from "react-redux";
import {
  addRestaurant,
  setDay,
  updateHoursWorking,
} from "../../features/restaurant/restaurantFeature";
import { RestaurantService } from "deliziora-client-module/client-web";
export default function NewOpeningHoursPage() {
  const [selectedDay, setSelectedDay] = useState("Segunda");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const restaurant = JSON.parse(localStorage.getItem("userData"));
  const dayStored = localStorage.getItem("@selectedDay");
  const restaurantRedux = useSelector((state) => state.restaurant);
  const [diaDeDescanso, setDiaDeDescanso] = useState(false);
  const [abertoDuranteTarde, setAbertoDuranteTarde] = useState(false);
  const [encerradoParaFerias, setEncerradoParaFerias] = useState(false);
  const [selectedDaySegmented, setSelectedDaySegmented] = useState("monday");
  const dispatch = useDispatch();

  useEffect(() => {
    RestaurantService.returnRestaurantById(restaurant._id.$oid)
      .then((res) => {
        dispatch(addRestaurant(res.data));
        setAbertoDuranteTarde(res.data.afternoonOpen)
        setEncerradoParaFerias(res.data.closedForHolidays)
        setDiaDeDescanso(res.data.dayClosed)
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    dispatch(setDay(dayStored));
  }, []);

  const handleDiaDeDescansoChange = (e) => {
    setDiaDeDescanso(e.target.checked);
  };

  const handleAbertoDuranteTardeChange = (e) => {
    setAbertoDuranteTarde(e.target.checked);
  };

  const handleEncerradoParaFeriasChange = (e) => {
    setEncerradoParaFerias(e.target.checked);
  };

  function getTimeOfRestaurantRedux(day) {
    switch (day) {
      case "Segunda":
        console.log("SEGUNDA VALUE", restaurantRedux.opening_hours.monday);
        return restaurantRedux.opening_hours.monday;
      case "Terça":
        return restaurantRedux.opening_hours.tuesday;
      case "Quarta":
        return restaurantRedux.opening_hours.wednesday;
      case "Quinta":
        return restaurantRedux.opening_hours.thursday;
      case "Sexta":
        return restaurantRedux.opening_hours.friday;
      case "Sábado":
        return restaurantRedux.opening_hours.saturday;
      case "Domingo":
        return restaurantRedux.opening_hours.sunday;

      default:
        break;
    }
  }

  const updateTimesForDay = (day, opening, closing) => {
    const dayToKeyMap = {
      Segunda: "monday",
      Terça: "tuesday",
      Quarta: "wednesday",
      Quinta: "thursday",
      Sexta: "friday",
      Sábado: "saturday",
      Domingo: "sunday",
    };

    const dayKey = dayToKeyMap[day];

    if (dayKey) {
      dispatch(
        updateHoursWorking({
          [dayKey]: {
            open: opening,
            closed: closing,
          },
        })
      );
    }
  };

  const handleSegmentedChange = (option) => {
    const dayToKeyMap = {
      Segunda: "monday",
      Terça: "tuesday",
      Quarta: "wednesday",
      Quinta: "thursday",
      Sexta: "friday",
      Sábado: "saturday",
      Domingo: "sunday",
    };
    const selectedDayKey = dayToKeyMap[option];
    if (selectedDayKey) {
      // setSelectedDay(option);

      setSelectedDaySegmented(selectedDayKey);
      localStorage.setItem("@selectedDay", option);
      dispatch(setDay(option));
    } else {
      console.log("ABABABA", dayToKeyMap[dayStored]);
      setSelectedDaySegmented(dayToKeyMap[dayStored]);
    }
  };

  const saveModifications = () => {
    RestaurantService.updateRestaurantById({
      id_restaurant: restaurant._id.$oid,
      name: restaurant.name,
      address: restaurant.address,
      latitude: restaurant.latitude,
      especialty: restaurant.especialty,
      complete_menu: restaurant.complete_menu,
      email: restaurant.email,
      longitude: restaurant.longitude,
      opening_hours: restaurantRedux.opening_hours,
      contact: restaurant.contact,
      description: restaurant.description,
      img: restaurant.img,
      afternoonOpen: abertoDuranteTarde,
      closedForHolidays: encerradoParaFerias,
      dayClosed: diaDeDescanso,
      categories: restaurant.categories,
      characteristics: restaurant.characteristics,
      updated_at: "",
    })
      .then((res) => {
        message.success("Dados actualizados com sucesso!");
        setInterval(() => {
          RestaurantService.returnRestaurantById(restaurant._id.$oid)
            .then((res) => {
              localStorage.setItem("userData", JSON.stringify(res.data));
            })
            .catch((err) => {
              console.error(err);
            });
        }, 1000);
      })
      .catch((err) => console.log(err));
  };

  const items = Object.keys({
    Segunda: 1,
    Terça: 2,
    Quarta: 3,
    Quinta: 4,
    Sexta: 5,
    Sábado: 6,
    Domingo: 7,
  }).map((day) => ({
    key: day,
    label: day,
    children: (
      <Flex
        style={{
          width: "100%",
          minHeight: "30vh",
          height: "100%",
          display: "flex",
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.077)",
        }}
      >
        <Flex
          justify="center"
          vertical
          style={{
            width: "100%",
            padding: "1.5rem",
          }}
        >
          <Flex
            vertical
            style={{
              marginTop: "1rem",
              width: "100%",
              minHeight: "30vh",
              display: "flex",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "stretch",
              backgroundColor: "white",
            }}
          >
            <TimeRangeSelector
              openingTime={
                getTimeOfRestaurantRedux(dayStored ? dayStored : "Segunda").open
              }
              closingTime={
                getTimeOfRestaurantRedux(dayStored ? dayStored : "Segunda")
                  .closed
              }
              onTimeChange={(opening, closing) =>
                updateTimesForDay(
                  dayStored ? dayStored : "Segunda",
                  opening,
                  closing
                )
              }
            />
          </Flex>
        </Flex>
      </Flex>
    ),
  }));
  return (
    <Flex vertical justify="center" align="center">
      <Typography.Title
        level={2}
        style={{
          margin: "auto",
          paddingTop: "1rem",
        }}
      >
        Horário de funcionamento
      </Typography.Title>
      <Flex
        align="center"
        justify="center"
        vertical
        style={{
          width: "90%",
          minWidth: "90%",
          maxWidth: "90%",
          height: "100%",
          alignSelf: "center",
          justifySelf: "center",
        }}
      >
        <Typography.Title
          level={4}
          style={{
            margin: "auto",
            paddingTop: "1rem",
            paddingBottom: "1rem",
          }}
        >
          Selecione o dia da semana
        </Typography.Title>
        <Tabs
          size="large"
          defaultActiveKey={dayStored ? dayStored : "Segunda"}
          tabPosition={"left"}
          tabBarGutter={7}
          tabBarStyle={{
            margin: "auto",
            justifyContent: "space-between",
            alignItems: "stretch",
          }}
          items={items}
          onChange={handleSegmentedChange}
          style={{
            width: "100%",
            borderRadius: "10px",
            boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.077)",
            backgroundColor: "white",
          }}
        />
      </Flex>
      <Flex
        vertical
        justify="space-between"
        style={{
          marginTop: "1rem",
          backgroundColor: "white",
          width: "90%",
          padding: "1.5rem",
          borderRadius: "10px",
          boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.077)",
        }}
      >
        <Flex
          style={{
            marginTop: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            backgroundColor: "white",
          }}
        >
          <Typography.Title level={4}>
            Dia de descanso
            <br />
            (Nota: o Restaurante estará encerrado para o dia.)
          </Typography.Title>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "orange",
              },
            }}
          >
            <Checkbox
              checked={diaDeDescanso}
              onChange={handleDiaDeDescansoChange}
            />
          </ConfigProvider>
        </Flex>
        <Divider />
        <Flex
          style={{
            marginTop: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            backgroundColor: "white",
          }}
        >
          <Typography.Title level={4}>
            Aberto durante a tarde
            <br />
            (Nota: o restaurante mantém-se aberto durante o pós-almoço)
          </Typography.Title>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "orange",
              },
            }}
          >
            <Checkbox
              checked={abertoDuranteTarde}
              onChange={handleAbertoDuranteTardeChange}
            />
          </ConfigProvider>
        </Flex>
        <Divider />
        <Flex
          style={{
            marginTop: "1rem",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            backgroundColor: "white",
          }}
        >
          <Typography.Title level={4}>
            Encerrado para ferias
            <br />
            (Nota: o Restaurante será exibido como encerrado até que a opção
            seja desativada.)
          </Typography.Title>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "orange",
              },
            }}
          >
            <Checkbox
              checked={encerradoParaFerias}
              onChange={handleEncerradoParaFeriasChange}
            />
          </ConfigProvider>
        </Flex>
      </Flex>
      <Flex
        gap={30}
        style={{
          marginTop: "1rem",
          backgroundColor: "white",
          width: "90%",
          padding: "1.5rem",
          borderRadius: "10px",
          boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.077)",
        }}
      >
        <Button
          type="primary"
          style={{
            backgroundColor: "black",
          }}
          onClick={() => saveModifications()}
        >
          Salvar Alterações
        </Button>
      </Flex>
    </Flex>
  );
}
